import React from 'react';
import { Route, Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppState } from '../../types';
import { isLoaded, isEmpty, FirebaseReducer } from 'react-redux-firebase';

type Props = {
  // tslint:disable-next-line:no-any
  component: any,
  exact: boolean,
  path: string,
  fallback?: string
};

const ProtectedRouteHoc: React.SFC<RouteComponentProps<{}> & Props> = (props) => {
const  { component: Component, fallback, ...rest } = props;
const auth = useSelector<AppState, FirebaseReducer.AuthState>(state => {
  return state.firebase.auth; 
});
return (isLoaded(auth) && !isEmpty(auth)) ? (
  <Route
    {...rest} 
    render={routeProps => {
      return <Component {...routeProps} />;
    }}
  />
)
: (<Redirect to={{ pathname: fallback || '/' }} />);
}

export default withRouter(ProtectedRouteHoc);